export default __webpack_public_path__ + "static/lysicrates-james-martin-banner-paper-background-057f9440f9380efab20c526c565050a2.png";